import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

export default function JobSitesPage() {
  const [sites, setSites] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ name:'', address:'', borough:'', client:'', pull_list_mode:'inherit', start_date:'', notes:'' });
  const [msg, setMsg] = useState('');

  const load = () => axios.get('/api/job-sites').then(r => setSites(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const loadDetail = (id) => {
    axios.get(`/api/job-sites/${id}`).then(r => setDetail(r.data)).catch(()=>{});
  };

  const selectSite = (site) => { setSelected(site); loadDetail(site.id); };

  const create = async () => {
    if (!form.name) { setMsg('Site name required'); return; }
    try {
      await axios.post('/api/job-sites', form);
      setMsg('Site created!'); setShowNew(false); setForm({ name:'', address:'', borough:'', client:'', pull_list_mode:'inherit', start_date:'', notes:'' }); load();
    } catch(e) { setMsg(e.response?.data?.error || 'Failed'); }
  };

  const statusDot = (s) => ({ active:'#3B6D11', on_hold:'#854F0B', completed:'#888' }[s] || '#888');

  return (
    <Layout>
      <div style={{marginBottom:'20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontSize:'20px',fontWeight:'700',color:'#0C447C',margin:0}}>Job sites</h1>
          <p style={{color:'#888',fontSize:'13px',marginTop:'4px'}}>{sites.length} active sites</p>
        </div>
        <button onClick={()=>setShowNew(!showNew)} style={{padding:'9px 18px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>+ New site</button>
      </div>
      {msg && <div style={{background:'#EAF3DE',borderRadius:'8px',padding:'10px 14px',color:'#27500A',fontSize:'13px',marginBottom:'14px'}}>{msg}</div>}

      {showNew && (
        <div style={{background:'#fff',borderRadius:'12px',border:'2px solid #185FA5',padding:'20px',marginBottom:'20px'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Create new job site</h2>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
            {[['name','Site name','text'],['address','Address','text'],['borough','Borough / area','text'],['client','Client / project','text'],['start_date','Start date','date']].map(([k,l,t]) => (
              <div key={k}>
                <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>{l}</label>
                <input type={t} value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})}
                  style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
              </div>
            ))}
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Pull list mode</label>
              <select value={form.pull_list_mode} onChange={e=>setForm({...form,pull_list_mode:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}}>
                <option value="inherit">Inherit from account</option>
                <option value="fluid">No approval required — fluid</option>
                <option value="managed">Approval required — managed</option>
              </select>
            </div>
          </div>
          <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
            <button onClick={()=>setShowNew(false)} style={{padding:'8px 16px',background:'#fff',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px',cursor:'pointer'}}>Cancel</button>
            <button onClick={create} style={{padding:'8px 16px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>Create site</button>
          </div>
        </div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'280px 1fr',gap:'16px'}}>
        <div>
          {sites.map((site,i) => (
            <div key={i} onClick={()=>selectSite(site)} style={{background:'#fff',borderRadius:'10px',border:selected?.id===site.id?'2px solid #185FA5':'1px solid #eee',padding:'14px 16px',marginBottom:'8px',cursor:'pointer'}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'4px'}}>
                <div style={{width:'8px',height:'8px',borderRadius:'50%',background:statusDot(site.status)}} />
                <div style={{fontWeight:'700',fontSize:'13px',color:'#222'}}>{site.name}</div>
              </div>
              <div style={{fontSize:'11px',color:'#888',marginBottom:'6px'}}>{site.address || site.borough}</div>
              <div style={{display:'flex',gap:'6px'}}>
                <span style={{background:'#E6F1FB',color:'#0C447C',padding:'2px 8px',borderRadius:'20px',fontSize:'11px'}}>{site.items_out} out</span>
                {site.overdue_count > 0 && <span style={{background:'#FCEBEB',color:'#A32D2D',padding:'2px 8px',borderRadius:'20px',fontSize:'11px'}}>{site.overdue_count} overdue</span>}
                {!site.foreman_user_id && <span style={{background:'#F1EFE8',color:'#5F5E5A',padding:'2px 8px',borderRadius:'20px',fontSize:'11px'}}>No foreman</span>}
              </div>
            </div>
          ))}
        </div>

        <div>
          {!selected ? (
            <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'40px',textAlign:'center',color:'#888'}}>Select a site to view details</div>
          ) : detail ? (
            <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'20px'}}>
              <h2 style={{fontSize:'17px',fontWeight:'700',color:'#0C447C',marginBottom:'4px'}}>{detail.name}</h2>
              <p style={{fontSize:'12px',color:'#888',marginBottom:'16px'}}>{detail.address} · {detail.client}</p>
              <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'10px',marginBottom:'20px'}}>
                <div style={{background:'#E6F1FB',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                  <div style={{fontSize:'22px',fontWeight:'700',color:'#0C447C'}}>{detail.equipment?.length || 0}</div>
                  <div style={{fontSize:'11px',color:'#555'}}>Items out</div>
                </div>
                <div style={{background:'#EAF3DE',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                  <div style={{fontSize:'22px',fontWeight:'700',color:'#27500A'}}>{detail.crew?.length || 0}</div>
                  <div style={{fontSize:'11px',color:'#555'}}>Crew members</div>
                </div>
                <div style={{background:'#FCEBEB',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                  <div style={{fontSize:'22px',fontWeight:'700',color:'#A32D2D'}}>{detail.equipment?.filter(e=>e.hours_overdue>0).length||0}</div>
                  <div style={{fontSize:'11px',color:'#555'}}>Overdue</div>
                </div>
              </div>
              <h3 style={{fontSize:'13px',fontWeight:'700',color:'#0C447C',marginBottom:'10px'}}>Crew</h3>
              {detail.crew?.map((member,i) => (
                <div key={i} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
                  <span style={{fontWeight:'500'}}>{member.first_name} {member.last_name}</span>
                  <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                    <span style={{background:'#E6F1FB',color:'#0C447C',padding:'2px 8px',borderRadius:'20px',fontSize:'11px',textTransform:'capitalize'}}>{member.role?.replace(/_/g,' ')}</span>
                    <span style={{color:'#888',fontSize:'11px'}}>{member.items_out} items out</span>
                  </div>
                </div>
              ))}
              {!detail.crew?.length && <p style={{color:'#888',fontSize:'13px'}}>No crew assigned</p>}
              <h3 style={{fontSize:'13px',fontWeight:'700',color:'#0C447C',margin:'16px 0 10px'}}>Equipment on site</h3>
              {detail.equipment?.map((eq,i) => (
                <div key={i} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
                  <div>
                    <span style={{fontWeight:'500'}}>{eq.item_name}</span>
                    <span style={{color:'#888',fontSize:'11px',marginLeft:'8px'}}>— {eq.first_name} {eq.last_name}</span>
                  </div>
                  <span style={{fontSize:'11px',color:eq.hours_overdue>0?'#A32D2D':'#27500A',fontWeight:'500'}}>
                    {eq.hours_overdue>0?`${Math.floor(eq.hours_overdue/24)}d overdue`:`Due ${new Date(eq.due_at).toLocaleDateString()}`}
                  </span>
                </div>
              ))}
              {!detail.equipment?.length && <p style={{color:'#888',fontSize:'13px'}}>No items currently on site</p>}
            </div>
          ) : <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'40px',textAlign:'center',color:'#888'}}>Loading...</div>}
        </div>
      </div>
    </Layout>
  );
}
